const LOGOS = {
  ag1: {
    name: 'AG1',
    logo: 'https://bottomless.imgix.net/ag1.svg',
  },
};

export const getStaticVendor = merchant => LOGOS[merchant];
